"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnreadCount = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var useUnreadCount = function useUnreadCount(_ref) {
  var role = _ref.role,
    peerId = _ref.peerId;
  var unreadCountSelector = role ? (0, _reactSdk.selectMessagesUnreadCountByRole)(role) : peerId ? (0, _reactSdk.selectMessagesUnreadCountByPeerID)(peerId) : _reactSdk.selectUnreadHMSMessagesCount;
  var unreadCount = (0, _reactSdk.useHMSStore)(unreadCountSelector);
  return unreadCount;
};
exports.useUnreadCount = useUnreadCount;